import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { EMPTY, Subject, Subscription } from 'rxjs';

import { EnvService } from '../_servicos/env.service';
import { MenuService } from '../_servicos/menu.service';

import { ModalAlertaService } from '../shared/modal-alerta.service';
import { Servidor } from './../_classes/servidor';
import { NotificacaoService } from '../_servicos/notificacao.service';
import { Retorno } from '../_classes/retorno';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
})
export class MenuComponent implements OnInit, OnDestroy {
  erros$ = new Subject<boolean>();

  inscricaoMenu: Subscription;
  inscricaoServidor: Subscription;

  PRODUCAO = false;

  possoMostrarMenu: boolean = false;

  public innerWidth: any;

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerWidth = window.innerWidth;
  }

  trueQuandoDesktop(): boolean {
    this._sEnv.mobile = false;
    return this.innerWidth >= 950;
  }

  trueQuandoMobile(): boolean {
    this._sEnv.mobile = true;
    return this.innerWidth < 950;
  }

  constructor(
    private menuService: MenuService,
    private alertService: ModalAlertaService,
    private _sEnv: EnvService,
    private _sNot: NotificacaoService
  ) {
    this.PRODUCAO =
      this._sEnv.ambiente.toUpperCase() == 'PRODUCAO' ||
      this._sEnv.ambiente.toUpperCase() == 'PROD';
    this.iniciarVerificacaoNotificacoes();
  }

  public get servidor(): Servidor {
    return this._sEnv.servidor;
  }

  navegarParaInicio() {
    console.log('Vou navegar');
    location.reload();
  }

  iniciarVerificacaoNotificacoes() {
    this._sEnv.tNotificacoes = setInterval(() => {
      if (
        EnvService.servidor2 &&
        !this._sEnv.notificacoesMostrando &&
        this._sEnv.bancoConectado
      ) {
        this._sNot
          .contarNotificacoesMinhasNaoRespondidas(
            EnvService.servidor2.nrMatricula
          )
          .subscribe({
            next: (x: Retorno) => {
              console.log(
                'iniciarVerificacaoNotificacoes2.Executei timer verificacaoNotificacao',
                x
              );
              if (Number(x.resultado)) {
                this._sEnv.notificacoesTotalNovas = x.resultado;
                console.log(
                  'NOTIFICACOES: ',
                  this._sEnv.notificacoesTotalNovas
                );
              }
              //this._sEnv.timeoutBuscaNotificacao += 1000;
            },
            error: (e) => {
              console.log(e);
              if (e.status === 0 && e.statusText === 'Unknown Error') {
                this._sEnv.bancoConectado = false;
              }
              return EMPTY;
            },
          });
      }
    }, this._sEnv.timeoutBuscaNotificacao);
  }

  ngOnInit() {
    this.innerWidth = window.innerWidth;
    this.possoMostrarMenu = this.menuService.getMostrarMenu();

    //console.log('incricao do mostraMenu');
    this.inscricaoMenu = this.menuService.mostrarMenuEmitter.subscribe(
      (mostrar: boolean) => {
        this.possoMostrarMenu = mostrar;
      },
      (e) => {
        this.handleError(e);
        return EMPTY;
      }
    );
  }

  ngOnDestroy() {
    if (this.inscricaoMenu) {
      this.inscricaoMenu.unsubscribe();
    }
    if (this.inscricaoServidor) {
      this.inscricaoServidor.unsubscribe();
    }
    if (this._sEnv.tNotificacoes) {
      this._sEnv.notificacoesMostrando = true;
    }
  }

  handleError(e: any) {
    this.erros$.next(true);
    this.alertService.mostrarAlertaPerigo(
      'Erro, tente novamente mais tarde',
      e
    );
  }
}
